import { CmhcIcon, CmhcIconSize, Modal, TabFields } from '@cmhc-schl/hearth-ui';
import { Box, MenuItem } from '@mui/material';
import React from 'react';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { LoanInventoryTableFields } from '../../types';
import { MRT_Row } from 'material-react-table';
import HbtMasterPoolLoansInventoryDetail from '../../../HbtMasterPoolLoansInventoryDetail/HbtMasterPoolLoansInventoryDetail';
import Popupmenu from 'Feature/V2/Shared_Portfolio/components/PopupMenu/Popupmenu';

interface RenderRowActionsProp {
  handleViewLoanDetailsActionRowClick: (tabList: TabFields) => void;
  selectedRowsData: LoanInventoryTableFields[];
  row: MRT_Row<LoanInventoryTableFields>;
  setSelectedRowsData: React.Dispatch<React.SetStateAction<LoanInventoryTableFields[]>>;
  setRowSelection: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  openHistoricalFlyout: () => void;
  setOpenAddRemarksFlyout: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenForceStatusFlyout: React.Dispatch<React.SetStateAction<boolean>>;
}

const RenderRowActions = ({
  row,
  selectedRowsData,
  handleViewLoanDetailsActionRowClick,
  setSelectedRowsData,
  openHistoricalFlyout,
  setRowSelection,
  setOpenAddRemarksFlyout,
  setOpenForceStatusFlyout
}: RenderRowActionsProp) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleOpenMenu = (event: any) => {
    const rowId = row.id;
    const newSelection = { [rowId]: true };
    setRowSelection(newSelection);
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const { t } = useTranslation('HbtMasterPool');

  const handleViewLoanDetail = () => {
    setSelectedRowsData((prev) => {
      const tabField: TabFields = {
        label: { value: row.original.cmhcAccountNumber },
        content: (
          <HbtMasterPoolLoansInventoryDetail
            loanReferenceNumber={row.original.lenderReferenceNumber}
            loanPortfolioEpipProcessingStatus={row.original.loanStatus}
            cmhcAccountNumber={row.original.cmhcAccountNumber}
            loanInventoryData={row.original}
          />
        )
      };
      handleViewLoanDetailsActionRowClick(tabField);

      return [...prev, row.original];
    });
    handleCloseMenu();
  };

  const handleHistoricalFlyout = () => {
    openHistoricalFlyout();
    handleCloseMenu();
  };
  const handleRemarkFlyout = () => {
    setOpenAddRemarksFlyout(true);
    handleCloseMenu();
  };
  const handleViewForceStatusFlyout = () => {
    setOpenForceStatusFlyout(true);
    handleCloseMenu();
  };

  return (
    <>
      <Box
        aria-label={`row-action-${row.id}`}
        className={styles.loanInventoryActionButton}
        onClick={handleOpenMenu}
      >
        <CmhcIcon size={CmhcIconSize.SMALL} type="icon_more_vertical" />
      </Box>

      <Popupmenu anchorElement={anchorEl} closeMenu={handleCloseMenu}>
        <Box className={styles.popupMenuContainer}>
          <MenuItem className={styles.popupMenu} onClick={handleViewForceStatusFlyout}>
            <CmhcIcon size={CmhcIconSize.SMALL} className={styles.icon_more} type="icon_override" />
            <span>{t('Override-Status')}</span>
          </MenuItem>
          <MenuItem className={styles.popupMenu} onClick={handleViewLoanDetail}>
            <CmhcIcon
              size={CmhcIconSize.SMALL}
              className={styles.icon_more}
              type="icon_read_more"
            />
            <span>{t('View-Loan-Details')}</span>
          </MenuItem>
          {row.original.remarks.length > 0 && (
            <MenuItem className={styles.popupMenu} onClick={handleHistoricalFlyout}>
              <CmhcIcon size={CmhcIconSize.SMALL} type="icon_history" />
              <span>{t('View-Historical-Data')}</span>
            </MenuItem>
          )}
          <MenuItem className={styles.popupMenu} onClick={handleRemarkFlyout}>
            <CmhcIcon size={CmhcIconSize.SMALL} type="icon_comment_add" />
            <span>{t('Add-Remarks-Action-Menu')}</span>
          </MenuItem>
        </Box>
      </Popupmenu>
    </>
  );
};

export default memo(RenderRowActions);
